/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PointDtoFromJSON, PointDtoToJSON, } from './PointDto.js';
/**
 * Check if a given object implements the LocationDto interface.
 */
export function instanceOfLocationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('geolocation' in value) || value['geolocation'] === undefined)
        return false;
    return true;
}
export function LocationDtoFromJSON(json) {
    return LocationDtoFromJSONTyped(json, false);
}
export function LocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'geolocation': PointDtoFromJSON(json['geolocation']),
    };
}
export function LocationDtoToJSON(json) {
    return LocationDtoToJSONTyped(json, false);
}
export function LocationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'geolocation': PointDtoToJSON(value['geolocation']),
    };
}
